import http from 'hub-http/clients/apiClient';
import formatCommunicationSubscriptions from '../formatters/formatCommunicationSubscriptions';
const BASE_URL = 'subscriptions/v1/definitions/by-subscription-channel';
const SMS_CHANNEL = 'SMS';
const WHATSAPP_CHANNEL = 'WHATSAPP';
export const createGetSmsSubscriptions = ({
  httpClient
}) => () => httpClient.get(`${BASE_URL}/${SMS_CHANNEL}`).then(formatCommunicationSubscriptions);
export const getSmsSubscriptions = createGetSmsSubscriptions({
  httpClient: http
});
export const createGetWhatsAppSubscriptions = ({
  httpClient
}) => () => httpClient.get(`${BASE_URL}/${WHATSAPP_CHANNEL}`).then(formatCommunicationSubscriptions);
export const getWhatsAppSubscriptions = createGetWhatsAppSubscriptions({
  httpClient: http
});